import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../services/auth.service';

@Injectable()
export class AuthErrorInterceptor implements HttpInterceptor {

    constructor(private authService: AuthService) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(
            catchError((error: HttpErrorResponse) => {

                const url = req.url.toLowerCase();

                const isLoginAttempt =
                    url.includes('/usuariosadmin/login') ||
                    url.includes('/usuarios/login');

                if (error.status === 401 && !isLoginAttempt) {
                    this.authService.handleSessionExpiration();
                }
                return throwError(() => error);
            })
        );
    }
}
